import script from "./AddProductPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./AddProductPopup.vue?vue&type=script&setup=true&lang=js"

import "./AddProductPopup.vue?vue&type=style&index=0&id=d681b4e8&lang=scss"

const __exports__ = script;

export default __exports__